<script setup>
setPageTitle(PageMeta.Quotes.Edit.Title)
definePage({ meta: PageMeta.Quotes.Edit.Meta })

import QuotesEditPage from '@/views/Previews/Quotes/QuotesEditPage.vue'

/* ** */
</script>

<template>
  <QuotesEditPage />
</template>
